import { render, staticRenderFns } from "./UploadimageCard.vue?vue&type=template&id=752c736e&scoped=true"
import script from "./UploadimageCard.vue?vue&type=script&lang=js"
export * from "./UploadimageCard.vue?vue&type=script&lang=js"
import style0 from "./UploadimageCard.vue?vue&type=style&index=0&id=752c736e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c736e",
  null
  
)

export default component.exports